import { Injectable } from '@angular/core';

 import { BehaviorSubject,Observable } from 'rxjs';
import Swal from 'sweetalert2';

 import swal from 'sweetalert2';


@Injectable()
export class NotificationService {

    private _notification: BehaviorSubject<string> = new BehaviorSubject(null);
    readonly notification$: Observable<string> = this._notification.asObservable();

    constructor() { }

    notify(message) {
         this._notification.next(message);
         setTimeout(() => this._notification.next(null), 3000);

        Swal.fire('AAAAAH', message);
    }
}
